module.exports = __webpack_public_path__ + "assets/img/team_active.c57d2c87.png";